import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        weeeFeeText: {
            textStyle: 'body-xsmall',
            color: 'text.default',
        },
        weeeFeeContainer: {
            gap: remCalc(0),
        },
        weeeFeeLabel: {
            gap: remCalc(8),
        },
    },
    variants: {
        orderSummary: {
            weeeFeeText: {
                textStyle: 'body-small',
            },
            weeeFeeContainer: {
                justifyContent: 'space-between',
                paddingY: remCalc(12),
            },
        },
    },
}
